// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FiltroCatalogoDinamico_wrap__ty0C- {
  border: 1px solid #e8eef3;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 16px;
  background: #fafbfc;
  /* o card é a referência de largura das tags (cqw), pra elas não saírem dele */
  container-type: inline-size;
  /* Uma coluna do tamanho da linha "Adicionar filtro" (até o botão "Limpar filtros"). */
  display: grid;
  grid-template-columns: fit-content(100%);
}

.FiltroCatalogoDinamico_addRow__w3SGM {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.FiltroCatalogoDinamico_title__\\+Nnk\\+ {
  font-size: 13px;
  font-weight: 700;
  color: #0d2847;
  margin-right: 4px;
}

.FiltroCatalogoDinamico_addSelect__Xyiil,
.FiltroCatalogoDinamico_input__6jHb2 {
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid #cfd8dc;
  font-size: 13px;
  font-family: inherit;
  background: #fff;
  color: #0d2847;
}

.FiltroCatalogoDinamico_addSelect__Xyiil {
  min-width: 220px;
}

.FiltroCatalogoDinamico_btnAdd__toJgN,
.FiltroCatalogoDinamico_btnLimpar__QAg8u {
  padding: 8px 14px;
  border-radius: 6px;
  border: 1px solid #cfd8dc;
  background: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  color: #0d2847;
}

.FiltroCatalogoDinamico_btnAdd__toJgN:disabled,
.FiltroCatalogoDinamico_btnLimpar__QAg8u:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.FiltroCatalogoDinamico_btnAdd__toJgN:hover:not(:disabled),
.FiltroCatalogoDinamico_btnLimpar__QAg8u:hover:not(:disabled) {
  background: #f5f5f5;
}

.FiltroCatalogoDinamico_ativosList__E3pPB {
  /* não aumenta a coluna do painel: as linhas acompanham a largura da linha "Adicionar filtro" */
  width: 0;
  min-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
}

.FiltroCatalogoDinamico_vazio__W4ZGB {
  margin: 0;
  font-size: 13px;
  color: #888;
}

.FiltroCatalogoDinamico_ativoRow__ESazv {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  padding: 6px 0;
}

.FiltroCatalogoDinamico_ativoLabel__bFz3n {
  min-width: 160px;
  font-size: 12px;
  font-weight: 600;
  color: #0d2847;
}

.FiltroCatalogoDinamico_ativoRemove__dRVpq {
  border: none;
  background: transparent;
  color: #b23b3b;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  padding: 2px 6px;
  /* fica logo à direita da linha (na margem do painel), igual em todos os filtros */
  position: absolute;
  left: calc(100% + 4px);
  top: 50%;
  transform: translateY(-50%);
}

/* Tags das opções marcadas: ao lado do × (fora do painel), alinhadas ao campo. */
.FiltroCatalogoDinamico_tagsLado__VlDvO {
  position: absolute;
  left: calc(100% + 40px);
  top: 0;
  bottom: 0;
  /* ocupa o que sobra do card à direita do campo (100cqw = card, 100% = campo) e quebra em linhas */
  display: flex;
  align-items: center;
  width: calc(100cqw - 100% - 40px);
}

.FiltroCatalogoDinamico_tagsConteudo__tR3mR {
  display: flex;
  flex-wrap: wrap;
  gap: 3px 4px;
  white-space: nowrap;
}

.FiltroCatalogoDinamico_tag__wvqNg {
  padding: 1px 5px 1px 8px;
  line-height: 16px;
  border-radius: 10px;
  background: #e8edf7;
  color: #18316e;
  font-size: 11px;
  font-weight: 600;
}

.FiltroCatalogoDinamico_tagRemove__pxPgQ {
  border: none;
  background: transparent;
  color: inherit;
  cursor: pointer;
  margin-left: 2px;
  padding: 0 2px;
  font-size: 13px;
  line-height: 1;
  opacity: 0.7;
}

.FiltroCatalogoDinamico_tagRemove__pxPgQ:hover {
  opacity: 1;
}

/* Campo que ocupa a largura toda da linha. */
.FiltroCatalogoDinamico_campoCheio__d2BbT {
  position: relative;
  width: 100%;
}

/* Vigência: De, Até e Regra; o nome mais curto deixa a Regra crescer até a borda direita. */
.FiltroCatalogoDinamico_ativoRowVigencia__uVkSs .FiltroCatalogoDinamico_ativoLabel__bFz3n {
  min-width: 120px;
}

.FiltroCatalogoDinamico_ativoRowVigencia__uVkSs .FiltroCatalogoDinamico_vigenciaWrap__dkZxF {
  flex: 1 1;
  min-width: 0;
}

/* Meses mais estreitos para título, De, Até e Regra caberem numa linha só. */
.FiltroCatalogoDinamico_ativoRowVigencia__uVkSs .FiltroCatalogoDinamico_vigenciaMes__eMP2b {
  width: 135px;
}

.FiltroCatalogoDinamico_rangeWrap__x82Gi {
  display: flex;
  align-items: center;
  gap: 8px;
}

.FiltroCatalogoDinamico_rangeSep__zFSho {
  font-size: 12px;
  color: #888;
}

/* TXM-671 — filtro de vigência: dois meses + regra */
.FiltroCatalogoDinamico_vigenciaWrap__dkZxF {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.FiltroCatalogoDinamico_vigenciaAviso__NBkMf {
  flex-basis: 100%;
  font-size: 12px;
  color: #b42318;
}

.FiltroCatalogoDinamico_vigenciaMes__eMP2b {
  width: 160px;
  flex-shrink: 0;
}

.FiltroCatalogoDinamico_campoFiltro__\\+ZIvJ {
  width: 320px;
  max-width: 100%;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/FiltroCatalogoDinamico/FiltroCatalogoDinamico.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,8EAA8E;EAC9E,2BAA2B;EAC3B,sFAAsF;EACtF,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,+FAA+F;EAC/F,QAAQ;EACR,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kFAAkF;EAClF,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA,iFAAiF;AACjF;EACE,kBAAkB;EAClB,uBAAuB;EACvB,MAAM;EACN,SAAS;EACT,kGAAkG;EAClG,aAAa;EACb,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,4FAA4F;AAC5F;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAW;EACX,YAAY;AACd;;AAEA,6EAA6E;AAC7E;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;AAChB","sourcesContent":[".wrap {\n  border: 1px solid #e8eef3;\n  border-radius: 8px;\n  padding: 14px 16px;\n  margin-bottom: 16px;\n  background: #fafbfc;\n  /* o card é a referência de largura das tags (cqw), pra elas não saírem dele */\n  container-type: inline-size;\n  /* Uma coluna do tamanho da linha \"Adicionar filtro\" (até o botão \"Limpar filtros\"). */\n  display: grid;\n  grid-template-columns: fit-content(100%);\n}\n\n.addRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n}\n\n.title {\n  font-size: 13px;\n  font-weight: 700;\n  color: #0d2847;\n  margin-right: 4px;\n}\n\n.addSelect,\n.input {\n  padding: 8px 10px;\n  border-radius: 6px;\n  border: 1px solid #cfd8dc;\n  font-size: 13px;\n  font-family: inherit;\n  background: #fff;\n  color: #0d2847;\n}\n\n.addSelect {\n  min-width: 220px;\n}\n\n.btnAdd,\n.btnLimpar {\n  padding: 8px 14px;\n  border-radius: 6px;\n  border: 1px solid #cfd8dc;\n  background: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n  color: #0d2847;\n}\n\n.btnAdd:disabled,\n.btnLimpar:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.btnAdd:hover:not(:disabled),\n.btnLimpar:hover:not(:disabled) {\n  background: #f5f5f5;\n}\n\n.ativosList {\n  /* não aumenta a coluna do painel: as linhas acompanham a largura da linha \"Adicionar filtro\" */\n  width: 0;\n  min-width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.vazio {\n  margin: 0;\n  font-size: 13px;\n  color: #888;\n}\n\n.ativoRow {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 0;\n}\n\n.ativoLabel {\n  min-width: 160px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #0d2847;\n}\n\n.ativoRemove {\n  border: none;\n  background: transparent;\n  color: #b23b3b;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 2px 6px;\n  /* fica logo à direita da linha (na margem do painel), igual em todos os filtros */\n  position: absolute;\n  left: calc(100% + 4px);\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n/* Tags das opções marcadas: ao lado do × (fora do painel), alinhadas ao campo. */\n.tagsLado {\n  position: absolute;\n  left: calc(100% + 40px);\n  top: 0;\n  bottom: 0;\n  /* ocupa o que sobra do card à direita do campo (100cqw = card, 100% = campo) e quebra em linhas */\n  display: flex;\n  align-items: center;\n  width: calc(100cqw - 100% - 40px);\n}\n\n.tagsConteudo {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3px 4px;\n  white-space: nowrap;\n}\n\n.tag {\n  padding: 1px 5px 1px 8px;\n  line-height: 16px;\n  border-radius: 10px;\n  background: #e8edf7;\n  color: #18316e;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.tagRemove {\n  border: none;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n  margin-left: 2px;\n  padding: 0 2px;\n  font-size: 13px;\n  line-height: 1;\n  opacity: 0.7;\n}\n\n.tagRemove:hover {\n  opacity: 1;\n}\n\n/* Campo que ocupa a largura toda da linha. */\n.campoCheio {\n  position: relative;\n  width: 100%;\n}\n\n/* Vigência: De, Até e Regra; o nome mais curto deixa a Regra crescer até a borda direita. */\n.ativoRowVigencia .ativoLabel {\n  min-width: 120px;\n}\n\n.ativoRowVigencia .vigenciaWrap {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n/* Meses mais estreitos para título, De, Até e Regra caberem numa linha só. */\n.ativoRowVigencia .vigenciaMes {\n  width: 135px;\n}\n\n.rangeWrap {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.rangeSep {\n  font-size: 12px;\n  color: #888;\n}\n\n/* TXM-671 — filtro de vigência: dois meses + regra */\n.vigenciaWrap {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.vigenciaAviso {\n  flex-basis: 100%;\n  font-size: 12px;\n  color: #b42318;\n}\n\n.vigenciaMes {\n  width: 160px;\n  flex-shrink: 0;\n}\n\n.campoFiltro {\n  width: 320px;\n  max-width: 100%;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `FiltroCatalogoDinamico_wrap__ty0C-`,
	"addRow": `FiltroCatalogoDinamico_addRow__w3SGM`,
	"title": `FiltroCatalogoDinamico_title__+Nnk+`,
	"addSelect": `FiltroCatalogoDinamico_addSelect__Xyiil`,
	"input": `FiltroCatalogoDinamico_input__6jHb2`,
	"btnAdd": `FiltroCatalogoDinamico_btnAdd__toJgN`,
	"btnLimpar": `FiltroCatalogoDinamico_btnLimpar__QAg8u`,
	"ativosList": `FiltroCatalogoDinamico_ativosList__E3pPB`,
	"vazio": `FiltroCatalogoDinamico_vazio__W4ZGB`,
	"ativoRow": `FiltroCatalogoDinamico_ativoRow__ESazv`,
	"ativoLabel": `FiltroCatalogoDinamico_ativoLabel__bFz3n`,
	"ativoRemove": `FiltroCatalogoDinamico_ativoRemove__dRVpq`,
	"tagsLado": `FiltroCatalogoDinamico_tagsLado__VlDvO`,
	"tagsConteudo": `FiltroCatalogoDinamico_tagsConteudo__tR3mR`,
	"tag": `FiltroCatalogoDinamico_tag__wvqNg`,
	"tagRemove": `FiltroCatalogoDinamico_tagRemove__pxPgQ`,
	"campoCheio": `FiltroCatalogoDinamico_campoCheio__d2BbT`,
	"ativoRowVigencia": `FiltroCatalogoDinamico_ativoRowVigencia__uVkSs`,
	"vigenciaWrap": `FiltroCatalogoDinamico_vigenciaWrap__dkZxF`,
	"vigenciaMes": `FiltroCatalogoDinamico_vigenciaMes__eMP2b`,
	"rangeWrap": `FiltroCatalogoDinamico_rangeWrap__x82Gi`,
	"rangeSep": `FiltroCatalogoDinamico_rangeSep__zFSho`,
	"vigenciaAviso": `FiltroCatalogoDinamico_vigenciaAviso__NBkMf`,
	"campoFiltro": `FiltroCatalogoDinamico_campoFiltro__+ZIvJ`
};
export default ___CSS_LOADER_EXPORT___;
